<style lang="less" scoped>
.first {position: relative;width: 1200px;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0px auto;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.chxxb {display: flex;flex-direction: column;}
.formBox{width: 1180px;margin-left: -20px;margin-top: 0px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border: 1px solid #e2e1e1;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.td_right {text-align: left;background-color: #fcfcfc;padding-left: 10px;}
.td_right span{font-size: 16px;}
.el-input {width: 400px;}
.el-select {width: 400px;}
.el-form-item {margin-bottom: 0;float: left;}
.btn{margin-top: 40px;}
</style>

<template>
  <div class="first">
    <div class="chxxb" id="hyrc">
      <el-form ref="form" :model="form" :rules="rules" class="formBox">
        <table>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('type1')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>选择项(任选一项)
            </td>
            <td class="td_right">
              <el-form-item>
                <el-radio v-model="form.type1" label="个人"><span class="radio">个人</span></el-radio>
                <el-radio v-model="form.type1" label="企业"><span class="radio">企业</span></el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('type2')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>选择项(任选一项)
            </td>
            <td class="td_right">
              <el-form-item>
                <el-radio v-model="form.type2" label="作为代表参加会议"><span class="radio">作为代表参加会议</span></el-radio>
                <el-radio v-model="form.type2" label="作为演讲者参加会议"><span class="radio">作为演讲者参加会议</span></el-radio>
                <el-radio v-model="form.type2" label="在活动中赞助或 展示"><span class="radio">在活动中赞助或展示</span></el-radio>
                <el-radio v-model="form.type2" label="媒体合作"><span class="radio">媒体合作</span></el-radio>
                <el-radio v-model="form.type2" label="其它咨询"><span class="radio">其它咨询</span></el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('namec')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>姓名
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.name" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('tel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>电话
            </td>
            <td class="td_right">
              <el-form-item prop="tel">
                <el-input v-model="form.tel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('maill')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.email" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gsname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gstype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('couture')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>所属国家
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nation" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('city')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>所属城市
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.city" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('opacity')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>留言
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.text" class="input" style="width:960px;"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="primary" @click="backtrack">返回</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 办会报名页
 */
export default {
  data()
  {
    return {
      form: {
        type1: '',
        type2: '',
        name: '',
        email: '',
        tel: '',
        gsname: '',
        gsaad: '',
        gstype: '',
        nation: '',
        city: '',
        text: ''
      },
      //表名
      tabname: 'dmcn_chxxb',
      //fld表数据
      fldData: []
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getdata(+nval.query.id)
      },
      immediate: true
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
  },
  methods: {
    // 获取参会报名信息
    getdata(num)
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 60,
        _exp: 'id=?',
        types: 'i',
        vals: num
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.type1 = ret[0].type1
        this.form.type2 = ret[0].type2
        this.form.name = ret[0].namec
        this.form.tel = ret[0].tel
        this.form.email = ret[0].maill
        this.form.gsname = ret[0].gsname
        this.form.gsaad = ret[0].gsaad
        this.form.gstype = ret[0].gstype
        this.form.nation = ret[0].couture
        this.form.city = ret[0].city
        this.form.text = ret[0].opacity
      })
    },
    // 返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ChbmShow.vue